export default {
  FETCH_USER_DATA: 'BRANDSTORE_FETCH_USER_DATA'
}